// components/organisms/serviceConnections/BannerList.tsx
import React from 'react'

import { BoxProps } from '@mantine/core'

import { CarouselOrListingBlockWrapper } from 'components/organisms/serviceConnections/carouselOrListingBlockWrapper'
import { ListBanner } from 'interfaces/types'

import { Banner } from './banner'

type BannerListProps = {
  listBanners: ListBanner[] | undefined
  isExternalLinkChat?: boolean
  isChatWoot?: boolean
  isPillarType?: boolean
  commonBannerProps: Record<string, any>
  bannerProps?: BoxProps
  classes: { bannerList?: string; bannerItem?: string } & Record<string, any>
  currentUrl?: string
  embedChatwootClick?: boolean
  onItemClick?: (v: string) => void
  applyCarousel?: boolean
}

export const BannerList: React.FC<BannerListProps> = ({
  listBanners,
  isExternalLinkChat = false,
  isChatWoot = false,
  isPillarType = false,
  commonBannerProps,
  bannerProps,
  classes,
  currentUrl,
  embedChatwootClick,
  onItemClick,
  applyCarousel = false,
}) => {
  if (!listBanners || listBanners.length === 0) return null

  return (
    <CarouselOrListingBlockWrapper
      showFullSlide
      lengthToCarouselDesktop={5}
      gapDesktop={18}
      disableCarousel={!applyCarousel} // <-- dùng prop applyCarousel đúng chỗ
    >
      <CarouselOrListingBlockWrapper.Slider
        arrow
        classNames={{
          listing: classes.bannerList,
          itemWrapper: classes.bannerItem,
        }}
        styles={(theme) => ({
          carouselViewport: {
            paddingTop: 4,
            paddingBottom: 10,
            paddingLeft: 4,
            [theme.fn.smallerThan('sm')]: {
              paddingLeft: 16,
              paddingRight: 16,
            },
          },
          progressRoot: {
            background: 'transparent',
            position: 'relative',
            [theme.fn.smallerThan('sm')]: {
              width: `calc(100% - 48px)`,
              marginLeft: 16,
            },
            '&:before': {
              position: 'absolute',
              content: '""',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: '#fff',
              opacity: 0.25,
            },
          },
          progressBar: {
            background: theme.colors.neutral[3],
          },
        })}
      >
        {listBanners.map((_banner, idx) => (
          <Banner
            key={`${_banner.title ?? 'banner'}-${idx}`} // đảm bảo unique key
            className={isPillarType ? 'with-shadow' : ''}
            onItemClick={onItemClick}
            banner={_banner}
            openChatWoot={
              !isExternalLinkChat &&
              (embedChatwootClick || _banner.url?.endsWith?.('#chatwoot'))
            }
            {...commonBannerProps}
            {...bannerProps}
            {...(isChatWoot && {
              'data-event-category': 'Chatwoot Chat',
              'data-event-action': 'Start Chat - Middle Page',
              'data-event-label': currentUrl,
            })}
            styles={(theme) => ({
              banner: {
                ...(isPillarType && {
                  boxShadow: theme.shadows.sm,
                }),
              },
            })}
          />
        ))}
      </CarouselOrListingBlockWrapper.Slider>
    </CarouselOrListingBlockWrapper>
  )
}
